import { AutocompleteOption } from '@mui/joy';
import type { CSSProperties, HTMLAttributes, ReactElement, ReactNode } from 'react';

type AutocompleteOptionProps = Omit<HTMLAttributes<HTMLLIElement>, 'color'> & { style: CSSProperties };
const TextOption = (props: AutocompleteOptionProps & { children: ReactNode }): ReactElement => {
  const { children, ...rest } = props;
  return <AutocompleteOption {...rest}>{children}</AutocompleteOption>;
};
export const MoreResultsItem = (props: AutocompleteOptionProps): ReactElement => {
  return <TextOption {...props}>Only top results shown</TextOption>;
};

export const NoResultsItem = (props: AutocompleteOptionProps): ReactElement => {
  return <TextOption {...props}>No results</TextOption>;
};

export const LoadingResultsItem = (props: AutocompleteOptionProps): ReactElement => {
  return <TextOption {...props}>Loading...</TextOption>;
};

export const TypeMoreResultsItem = (props: AutocompleteOptionProps): ReactElement => {
  return <TextOption {...props}>Type to search...</TextOption>;
};
